import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { eDetailsView } from "./details-veiw.enum";

@Component({
    selector: 'app-tablet-view-tabs',
    templateUrl: './tablet-view-tabs.component.html',
    styleUrls: ['./tablet-view-tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabletViewTabsComponent {
    @Input() detailsView: eDetailsView = eDetailsView.Info;
    @Output() viewChanged: EventEmitter<eDetailsView> = new EventEmitter<eDetailsView>();

    eDetailsView = eDetailsView;

    // LABELS = {
    //     infoView: 'תצוגת מסמך',
    //     mapView: 'תצוגת מפה',
    // }

    infoViewShow() {
        this.viewChanged.emit(eDetailsView.Info);
    }

    mapViewShow() {
        this.viewChanged.emit(eDetailsView.Map);
    }

}